export default {
  unavailableTitle: 'Produkt není dostupný',
  unavailableText: 'Tento produkt se nepodařilo načíst. Mohl být odstraněn nebo je katalogové API nedostupné.',
  backToCatalog: 'Zpět do katalogu',
  catalog: 'Katalog',
  baseGame: 'Základní hra',
  inStock: 'Skladem',
  outOfStock: 'Vyprodáno',
  inCart: 'V košíku',
  addToCart: 'Přidat do košíku',
  addToWishlist: 'Přidat do oblíbených',
  logInToProceed: 'Pro pokračování se přihlaste',
  aboutTheGame: 'O hře',
  noDescription: 'Popis není k dispozici.',
  showMore: 'Zobrazit více',
  showLess: 'Zobrazit méně',
  details: 'Podrobnosti',
  releaseDate: 'Datum vydání',
  metacritic: 'Metacritic',
  developer: 'Vývojář',
  publisher: 'Vydavatel',
  platform: 'Platforma',
  ageRating: 'Věkové hodnocení',
  region: 'Region',
  regionalRestrictions: 'Regionální omezení',
  regionalLimitations: 'Regionální omezení: Aktivace pouze v regionu {region}.',
  regionLine: 'Region: {regions}.',
  activationDetails: 'Podrobnosti o aktivaci',
  systemRequirements: 'Systémové požadavky',
  visuals: 'Obrázky',
  similarGames: 'Podobné hry',
  minimum: 'Minimální',
  recommended: 'Doporučené',
  regionFree: 'Bez omezení regionu',
  noRegionRestriction: 'Bez regionálních omezení. Tento klíč lze aktivovat celosvětově.',
  noImage: 'Bez obrázku',
  steamStep1: 'Otevřete klienta Steam',
  steamStep2: 'Klikněte na „Přidat hru“',
  steamStep3: 'Vyberte „Aktivovat produkt na Steamu“',
  steamStep4: 'Zadejte kód podle pokynů',
  epicStep1: 'Otevřete Epic Games Launcher',
  epicStep2: 'Přihlaste se ke svému účtu',
  epicStep3: 'Přejděte do knihovny a uplatněte kód',
  epicStep4: 'Stáhněte a hrajte',
  eaStep1: 'Otevřete aplikaci EA / Origin',
  eaStep2: 'Otevřete nabídku a zvolte „Uplatnit kód“',
  eaStep3: 'Zadejte svůj klíč PixelKey',
  eaStep4: 'Stáhněte a hrajte',
  genericStep1: 'Otevřete oficiálního klienta / launcher',
  genericStep2: 'Najděte „Aktivovat produkt“ nebo „Uplatnit kód“',
  genericStep3: 'Zadejte svůj klíč PixelKey',
  genericStep4: 'Stáhněte a hrajte',
};
